import type { RerunJobResult } from "../../shared/types";
import { postRequired } from "./apiClient";

export function rerunAcrJob(jobId: string): Promise<RerunJobResult> {
  return postRequired<{ jobId: string }, RerunJobResult>(`/admin/jobs/${encodeURIComponent(jobId)}/rerun-acr`, { jobId });
}
